module.exports = __webpack_public_path__ + "img/media.8a7862ae.png";